export default {
  path: 'omsecondhand',
  meta: {
    title: '二手交易'
  },
  component: () => import('@/components/parent-view'),
  name: 'omsecondhand',
  children: [
    {
      path: 'manage',
      name: 'omsecondhand-manage',
      meta: {
        title: '二手交易管理'
      },
      component: () => import('@/view/secondhand/index.vue')
    },
    {
      path: 'ask',
      name: 'omsecondhand-ask',
      meta: {
        title: '咨询人数',
        hideInTabBar: true
      },
      component: () => import('@/view/v5/secondhand/ask.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/secondhand.js